/**
 * @method getRemoteTracks
 * @return {Array} List of active Track objects the Peer has received remotely.
 */
export default function getRemoteTracks () {
  const { proxyPeer, trackManager, log } = this
  log.info('Getting remote tracks.')

  // Return the list of Tracks from active receivers.
  return (
    proxyPeer
      .getReceivers()
      /**
       * Remove any Receivers that do not have an associated track.
       * We only want to retrieve Receivers that do have tracks, because those are
       *    the remote tracks that have been added to the Peer.
       * Receivers without tracks are part of a Transceiver where the Sender has
       *    a local track, but no remote track has been added to it. We don't
       *    care about this for the "get remote tracks" operation.
       */
      .filter(receiver => Boolean(receiver.track))
      .map(receiver => trackManager.get(receiver.track.id))
      .filter(track => {
        // Make sure the trackManager has the track and that its active.
        // It's possible that Peer has the receiver but not the actual track yet.
        return track && track.getState().state === 'live' && track.getStream().active
      })
  )
}
